import { Box, styled } from '@mui/material';
import clsx from 'clsx';
import React from 'react';

import dagbladetLogo from '../assets/dagbladet.svg';

import { ArrowLink } from './ArrowLink.tsx';

const Root = styled('div', { shouldForwardProp: (p) => p !== 'noPadding' })<{
  noPadding?: boolean;
}>(({ theme, noPadding }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(3),
  textAlign: 'left',

  ...(!noPadding && {
    background: theme.palette.background.default,
    color: theme.palette.text.default,
    borderRadius: '8px',
    paddingInline: theme.spacing(2),
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(1),
  }),

  [theme.breakpoints.up('md')]: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: theme.spacing(5),

    ...(!noPadding && {
      paddingTop: theme.spacing(4),
      paddingInline: theme.spacing(5),
      paddingBottom: theme.spacing(3),
    }),
  },
  [theme.breakpoints.up('lg')]: {
    gap: theme.spacing(10),
    ...(!noPadding && {
      paddingTop: theme.spacing(9),
      paddingInline: theme.spacing(10),
      paddingBottom: theme.spacing(6),
    }),
  },
}));

export type WinnerQuotePhotoProps = {
  photo: string;
  photoAlt: string;
  photoCaption: string;
  quote: string;
  quoteCaption: string;
  link: string;
  noPadding?: boolean;
  large?: boolean;
};

export const WinnerQuotePhoto: React.FC<WinnerQuotePhotoProps> = ({
  photo,
  photoAlt,
  photoCaption,
  quote,
  quoteCaption,
  link,
  noPadding,
  large,
}) => {
  return (
    <Root noPadding={noPadding}>
      <Box
        sx={{
          order: { md: 1 },
          flex: 2,
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column' },
            mb: { md: 0, lg: 6 },
            pt: { xs: 4, md: 0 },
          }}
        >
          <Box
            sx={{
              fontSize: 200,
              color: 'primary.main',
              ml: 'auto',
              lineHeight: 1,
              mt: -6,
              mr: 1,
              height: '60px',
            }}
          >
            “
          </Box>
          <Box
            sx={{
              paddingRight: { lg: '100px' },
            }}
          >
            <img src={dagbladetLogo} alt="Dagbladet logo" />
            <div
              className={clsx(
                'mt-4 mb-6 italic',
                large ? 'typography-v1-h1' : 'typography-v1-body2',
              )}
            >
              {quote}
            </div>
            <div className="mb-8 typography-v1-body4">{quoteCaption}</div>

            <p className="typography-v1-body4">
              <ArrowLink to={link} target="_blank">
                Les artikel
              </ArrowLink>
            </p>
          </Box>
        </Box>
      </Box>
      <figure style={{ margin: 0, flex: 1 }}>
        <img
          src={photo}
          alt={photoAlt}
          width={920}
          height={920}
          style={{ maxWidth: '100%', height: 'auto' }}
        />
        <figcaption className="mt-1 typography-v1-body4">{photoCaption}</figcaption>
      </figure>
    </Root>
  );
};
